import {connect} from 'react-redux';
import {LabelTubes as Component} from './LabelTubes';
import {
  showModal,
  labelReactionTubes,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    labelTubeSamples: state.notebook.currentSection.labelTubeSamples,
  }
}

function mapDispatchToProps(dispatch) {
  return {

    showModal: (data) =>{
      dispatch(showModal(data))
    },
   
    labelReactionTubes: (data) =>{
      dispatch(labelReactionTubes(data))
    },
 
  }
}

export const LabelTubes = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
